import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    Renderer2,
} from '@angular/core';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { SharedLayoutsService } from '../shared-layouts.service';

SwiperCore.use([Autoplay, Pagination]);

@Component({
    selector: 'app-carousel-banner-v3',
    templateUrl: './carousel-banner-v3.component.html',
    styleUrls: ['./carousel-banner-v3.component.scss'],
})
export class CarouselBannerV3Component implements OnInit, AfterViewInit {
    @Input() item: any;
    @Input() showShimmer = true;
    @Output() emitLink: EventEmitter<string> = new EventEmitter();

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        protected sharedLayoutsService: SharedLayoutsService
    ) {}

    processLink(link: string) {
        this.emitLink.emit(link);
    }

    ngOnInit(): void {}

    onSlideChange(event: any) {
        this.updateProgressBar();
    }

    ngAfterViewInit() {
        this.updateProgressBar();
    }

    private updateProgressBar() {
        const activeBullet = this.el.nativeElement.querySelector(
            '.swiper-pagination-bullet-active'
        );
        const existingProgressBar =
            this.el.nativeElement.querySelector('.progress-bar');
        if (existingProgressBar) {
            existingProgressBar.remove();
        }

        const progressBar = this.renderer.createElement('div');

        this.renderer.addClass(progressBar, 'progress-bar');
        // this.renderer.setStyle(progressBar, 'width', '6px');

        if (activeBullet) {
            this.renderer.appendChild(activeBullet, progressBar);
        }
    }
}
